import * as React from 'react'

import { Label, Checkmark, Control } from './style'
import { useField } from 'formik'

import { Error as FieldError } from '../field/style'

import IconCheckmark from './assets/icon-checkmark.svg'
import { SpaceProps } from 'styled-system'
import { Box } from '../layout'

type Props = SpaceProps & {
  name?: string
  label: React.ReactNode
  alignTop?: boolean
  checked: boolean
  onChange: (event: React.ChangeEvent<HTMLInputElement>) => void
  onBlur?: (event: React.FocusEvent<HTMLInputElement>) => void
  error?: string
  disabled?: boolean
}

export const Checkbox = ({
  name,
  label,
  alignTop,
  checked,
  onChange,
  onBlur,
  error,
  disabled,
  ...space
}: Props) => {
  const control = (
    <>
      <Checkmark
        name={name}
        checked={checked}
        onChange={onChange}
        onBlur={onBlur}
        disabled={disabled}
        data-invalid={!!error}
      />
      <IconCheckmark />
    </>
  )

  return (
    <Box {...space}>
      <Label data-disabled={!!disabled} data-align-top={alignTop || undefined}>
        {alignTop ? <Control>{control}</Control> : control}
        {alignTop ? <span>{label}</span> : label}
      </Label>
      {error && <FieldError>{error}</FieldError>}
    </Box>
  )
}

type CheckboxFieldProps = SpaceProps & {
  name: string
  label: React.ReactNode
  alignTop?: boolean
  onChange?: (event: React.ChangeEvent<HTMLInputElement>) => void
}

export const CheckboxField = ({
  name,
  label,
  alignTop,
  onChange,
  ...space
}: CheckboxFieldProps) => {
  const [field, meta] = useField<boolean>({ name })

  return (
    <Checkbox
      label={label}
      alignTop={alignTop}
      name={field.name}
      checked={field.value}
      onChange={onChange || field.onChange}
      onBlur={field.onBlur}
      error={meta.touched && meta.error ? meta.error : undefined}
      {...space}
    />
  )
}
